// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-FigureFooter----index-module---root---3onr_","section":"src-components-FigureFooter----index-module---section---1a6Mn","social":"src-components-FigureFooter----index-module---social---1ro1z","socialAction":"src-components-FigureFooter----index-module---socialAction---1IHuQ","list":"src-components-FigureFooter----index-module---list---2VO5o","term":"src-components-FigureFooter----index-module---term---3yT5I","definition":"src-components-FigureFooter----index-module---definition---1AMH6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FigureFooter/index.module.css
// module id = 606
// module chunks = 168707334958949